export const environment = {
  production: true,
  authConfig: {
    baseUrl: 'https://www.freelancer.com/auth',
    switchAccountHackyEndpoint:
      'https://www.freelancer.com/ajax-api/navigation/switchaccount.php',
    authHashCookie: 'GETAFREE_AUTH_HASH_V2',
    userIdCookie: 'GETAFREE_USER_ID',
    csrfCookie: 'XSRF-TOKEN',
  },
  uiConfig: {
    assetsBaseUrl: 'https://www.f-cdn.com/assets/webapp/assets',
    locale: 'en',
  },
  mapsConfig: {
    apiKey: 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8',
    libraries: ['places'],
  },
  datastoreConfig: {
    webSocketUrl: 'https://notifications.freelancer.com',
    enableStoreFreeze: false,
  },
  freelancerHttpConfig: {
    baseUrl: 'https://www.freelancer.com',
    apiBaseUrl: 'https://www.freelancer.com/api',
    ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
  },
  threatmetrixConfig: {
    baseUrl: 'https://cdn1.f-cdn.com',
    orgId: 'lar9e74p',
  },
  trackingConfig: {
    trackingEndpoint: 'https://t.freelancer.com/0px.gif',
    sessionCookie: '_tracking_session',
    navigationPerformanceSamplingRate: 1,
    enableErrorTracking: true,
    sentryDsn: 'https://29cfb544702b48e0985e69cd3ef5e84f@sentry.io/1410063',
    sentryEnvironment: 'production',
    gitRevision: '96a1a195e6b26f212aefc18acbb5a679d10cb736',
    buildTimestamp: 1553737098140,
    gaTrackingId: 'UA-223765-6',
    awGoogleConversionId: undefined,
    facebookPixelId: 1442861529284463,
  },
  billingConfig: {
    baseUrl: 'https://api.freelancerbilling.com',
  },
  facebookConfig: {
    appId: undefined,
  },
  languageCookie: 'GETAFREE_LANGUAGE',
  whitelistCookie: 'IS_WHITELIST_USER',
  siteName: 'Freelancer',
};
